import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import "./lib/dayjs";
import App from "./App.tsx";
import "./index.css";
import { initSentry } from "./lib/sentry";

initSentry();


ReactDOM.createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
